import { OS, OSNum, query } from '@/modules/util';
import { QQ_APP_ID, WX_APP_ID, baseFetchTool, businessFetchTool } from './base';
import { useAuth } from '@/store/auth';


const appid = query('appid');
const scene = query('scene');

export interface GetCardsReq {
  appid: string;
  scene: string;
  source: number;
  support_continue_month_extra: number;
  qua2: string;
};


const testData = {
  cards: [
    {
      name: '连续包月-pc',
      price: '600',
      desc: '',
      tag: '',
      coupons: [],
      original_price: '600',
      goods_id: '3484',
      offer_id: '1450141493',
      zone_id: '1',
      product_id: 'QQLLQGJQYKQQ_continuous_month_pid',
      service_code: 'QQLLQGJQYKQQ',
      service_name: ' QQ浏览器工具权益卡_QQ业务',
      autopay_productid: 'QQLLQGJQYKQQ_continuous_month_pid',
      autopay_type: 1,
      card_type: 1,
      order_weight: 7,
      platform: 4,
      login_type: 1,
      filter_type: 2,
      crossed_text: {
        text: '¥6元/月',
        is_crossed: false,
      },
      product: 0,
      h5_continue_month_extra: '',
      min_version_list: [],
      max_version_list: [],
      profile_id_list: [],
      mutex_goods_ids: [],
      payment_details: [],
      enquity_type: 0,
      extra_cards: [],
      extra_card_ids: [
        '',
      ],
      opened_cards_excluded_type: {},
    },
    {
      name: '1个月-pc',
      price: '800',
      desc: '',
      tag: '',
      coupons: [],
      original_price: '800',
      goods_id: '3486',
      offer_id: '1450141493',
      zone_id: '1',
      product_id: 'monthlypc',
      service_code: 'QQLLQGJQYKQQ',
      service_name: 'QQ浏览器工具权益卡会员_QQ',
      autopay_productid: '',
      autopay_type: 0,
      card_type: 1,
      order_weight: 1,
      platform: 4,
      login_type: 1,
      filter_type: 3,
      crossed_text: {
        text: '8元/月',
        is_crossed: false,
      },
      product: 0,
      h5_continue_month_extra: '',
      min_version_list: [],
      max_version_list: [],
      profile_id_list: [],
      mutex_goods_ids: [],
      payment_details: [],
      enquity_type: 1,
      extra_cards: [],
      extra_card_ids: [
        '',
      ],
      opened_cards_excluded_type: {},
    },
  ],
  ts: '1701245191',
  style: null,
  anchor_goods_id: '',
  extra_card_wordings: {
    1: {
      head: '工具权益卡已包含500MB云空间',
      name: '1T小云盘加项包',
      desc: '云空间扩容至1T·大文件上传·原画备份',
    },
  },
};
console.log('🚀 ~ file: card.ts:104 ~ testData:', testData);


// 获取sku信息
export const getCards = (
  successCallback: any,
  errorCallback: any,
) => {
  const appid = query('appid');
  const scene = query('scene');
  baseFetchTool(
    'GetCards',
    {
      appid,
      scene,
      platform: OS(),
    },
    successCallback,
    errorCallback,
  );
};


// 获取个人权益信息
export const getPrivilegeInfo = (
  successCallback: any,
  errorCallback: any,
) => {
  const appid = query('appid');
  const scene = query('scene');
  baseFetchTool(
    'GetPrivilegeInfo',
    {
      appid,
      scene,
      platform: OS(),
    },
    successCallback,
    errorCallback,
  );
};

// 获取列表
export async function getPrivilegeInfoAsync(): Promise<any> {
  return new Promise((resolve, reject) => {
    getPrivilegeInfo((res: unknown) => {
      console.log('🚀 ~ file: index.ts:45 ~ list ~ res:', res);
      resolve(res);
    }, (err: any) => {
      console.log('🚀 ~ file: index.ts:47 ~ list ~ err:', err);
      reject(err);
    });
  });
};

// 获取sItem信息
export const getItems = (
  successCallback: any,
  errorCallback: any,
) => {
  baseFetchTool(
    'GetItems',
    {
      appid,
      scene,
      platform: OS(),
    },
    successCallback,
    errorCallback,
  );
};

const tokenTypeMap = {
  4: 7,
  1: 4,
  2: 2,
  6: 9,
};

// 通用的次数查询能力,用于业务接入工具权益卡
export const queryConsumeCount = (
  successCallback: any,
  errorCallback: any,
) => {
  const { accountInfo } = useAuth.storeInfo();
  const { deviceInfo } = useAuth.storeInfo();
  const type = accountInfo.logintype === 'qq' ? 4 : 2;
  businessFetchTool(
    'QueryConsumeCount',
    {
      auth_info: {
        account_type: type,
        appid: accountInfo.logintype === 'qq' ? QQ_APP_ID : WX_APP_ID,
        account_id: accountInfo.openid,
        token_type: tokenTypeMap[type],
        token: accountInfo.accessToken,
        qbid: accountInfo.qbid,
      },
      user_info: {
        guid: deviceInfo.tguid,
        qimei36: deviceInfo.qimei36,
        qua2: deviceInfo.qua2,
      },
      buissness_info: {
        appid,
        scene,
      },
      platform: OSNum(),
    },
    (res) => {
      console.log('🚀 ~ res:', res);
      if (res.header.retCode === 0) {
        successCallback(res);
      } else {
        errorCallback(res);
      }
    },
    errorCallback,
  );
};

export const queryConsumeCountAsync = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    queryConsumeCount((res: unknown) => {
      console.log('🚀 ~ file: index.ts:45 ~ list ~ res:', res);
      resolve(res);
    }, (err: any) => {
      console.log('🚀 ~ file: index.ts:47 ~ list ~ err:', err);
      reject(err);
    });
  });
};
